import { render } from "./DigitalPrintingRequestList.vue?vue&type=template&id=7310f77f"
import script from "./DigitalPrintingRequestList.vue?vue&type=script&lang=js"
export * from "./DigitalPrintingRequestList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__